
<template>
  <vs-popup class="holamundo" title="جزئیات تراکنش" :active.sync="popupActive">
    <div class="vx-row" v-if="transaction">
      <div class="vx-col w-full">
        <!-- <div class="vx-row">
          <div class="vx-col sm:w-1/3">پرداخت کننده</div>
          <div class="vx-col">{{transaction.sourceName}} ({{transaction.sourceMobile}})</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">نام پذیرنده</div>
          <div class="vx-col">{{transaction.destinationName}} ({{transaction.destinationMobile}})</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3"><code>مبلغ</code></div>
          <div class="vx-col">
            <code>{{transaction.transaction.amount}}</code></div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">تاریخ پرداخت</div>
          <div class="vx-col">{$moment(transaction.paymentDateTime).format('jYYYY/jM/jD')}}</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">ساعت پرداخت</div>
          <div class="vx-col">{$moment(transaction.paymentDateTime).format('HH:mm:ss')}}</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">وضعیت</div>
          <div class="vx-col">{{TransactionState[transaction.transaction.state] }}</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">نوع پرداخت</div>
          <div class="vx-col">{{PaymentType[transaction.transaction.paymentType].title }}</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">درگاه</div>
          <div class="vx-col">{{PaymentGateway[transaction.transaction.paymentGateway] }}</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">شماره مرجع</div>
          <div class="vx-col">{{transaction.transaction.referenceNumber}}</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">شماره پیگیری بانک</div>
          <div class="vx-col">{{transaction.transaction.traceNumber}}</div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/3">شماره پیگیری 20پی</div>
          <div class="vx-col">{{transaction.transaction.trackingNumber}}</div>
        </div>
        <div class="vx-row sm:w-1/3" v-for="item in resultMessage" :key="item">
          <div class="vx-col">{{item.key}}</div>
          <div class="vx-col">{{item.value}}</div>
        </div>-->
        <table>
          <tr>
            <td class="pr-1">وضعیت پرداخت:</td>
            <td>
              {{TransactionState[transaction.state].title}}
              <feather-icon
                :title="TransactionState[transaction.state].title"
                :icon="TransactionState[transaction.state].icon"
                :svgClasses="[`h-6 w-6 stroke-current text-${TransactionState[transaction.state].color}`]"
              ></feather-icon>
            </td>
          </tr>
          <tr>
            <td class="pr-1">نوع پرداخت:</td>
            <td>{{PaymentType[transaction.paymentType].title}}</td>
          </tr>
          <tr v-for="item in transaction.receiptValues" :key="item.key">
            <td class="pr-1">{{item.key}}:</td>
            <td>{{item.value}}</td>
          </tr>
          <tr v-if="transaction.formDescriptionValues">
            <td class="pr-1">{{transaction.formDescriptionValues.Key}}:</td>
            <td>{{transaction.formDescriptionValues.Value}}</td>
          </tr>
        </table>
      </div>
    </div>
  </vs-popup>
</template>
<style scoped>
[dir="rtl"] tr td:last-child {
  direction: ltr;
  text-align: right;
}
</style>

<script>
import { TransactionState, PaymentType, PaymentGateway } from "@/enums.js";
export default {
  name: "transaction-details",
  props: {},
  data() {
    return {
      transactionId: null,
      popupActive: false,
      transaction: null,
      resultMessage: null,
      TransactionState,
      PaymentType,
      PaymentGateway,
    };
  },
  watch: {
    transactionId: {
      handler: function (newValue) {},
    },
  },
  methods: {
    show(transactionId) {
      if (!transactionId) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا!",
          text: "تراکنش مورد نظر یافت نشد",
        });
        return;
      }
      this.transaction = {};
      this.popupActive = true;
      this.$vs.loading();
      let payload = { params: { id: transactionId, userType: 1 } };
      this.$http
        .get("/api/services/app/Transactions/GetTransactionDetails", payload)
        .then((response) => {
          this.transaction = response.data.result;
          this.transactionId = null;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
  },
  mounted() {},
};
</script>
